import { mergeStyles, Stack, Text, useTheme } from "@fluentui/react";
import {
    EProduct as FAM_EProduct,
    IBenefit as FAM_IBenefit
} from "model/FlexibleAttributeModel";
import React, { useMemo, } from 'react';

interface IProps {
    benefit: FAM_IBenefit
}


const BenefitSummary: React.FC<IProps> = ({ benefit }) => {


    const theme = useTheme();

    const styleSummary = useMemo(() => {
        const styleSummary: Record<string, React.CSSProperties> = {
            "dl": {
                width: '100%',
                padding: '5px',
            },
            "dt": {
                fontWeight: 680,
                textAlign: 'right',
                width: "120px",
                padding: '5px',
            },
            "dd": {
                padding: '5px',
            }
        }
        return styleSummary;
    }, []);

    const tBodyClass = useMemo(() => {
        return mergeStyles({
            "td": {
            },
            "& > :nth-child(even)": {
                backgroundColor: theme.semanticColors.bodyDivider,
            }
        });
    }, [theme]);

    const headerStyles = useMemo(() => {
        const headerStyles = { root: { fontWeight: '680' } }
        return headerStyles;
    }, []);

    const tierListClass = useMemo(() => {
        return mergeStyles({
            rowGap: 6,
        });
    }, []);

    const tierItemClass = useMemo(() => {
        return mergeStyles({
            border: `1px solid ${theme.palette.neutralLight}`,
            borderRadius: 4,
            padding: 8,
            backgroundColor: theme.semanticColors.bodyBackground,
        });
    }, [theme]);

    const tierMetaClass = useMemo(() => {
        return mergeStyles({
            color: theme.palette.neutralSecondary,
        });
    }, [theme]);

    const showFundingType = (benefit.product?.value !== FAM_EProduct.Yes);

    return (
        <table style={styleSummary.dl}>
            <tbody className={tBodyClass}>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles} >Name</Text></td>
                    <td style={styleSummary.dd}><Text>{benefit.name}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Tier Set</Text></td>
                    <td style={styleSummary.dd}>
                        <Stack className={tierListClass}>
                            <Text key={"tierset"}>{benefit.tierSetRef?.name ?? '-'}</Text>
                            {benefit.tiers?.map(t => (
                                <Stack key={t.id} className={tierItemClass} tokens={{ childrenGap: 4 }}>
                                    <Text variant="smallPlus">
                                        {t?.name ?? '-'}
                                        {t?.description ? ` - ${t.description}` : ''}
                                        {t?.bcbs_name ? ` (${t.bcbs_name})` : ''}
                                    </Text>
                                    <Text variant="small" className={tierMetaClass}>
                                        PCP/Specialist: {t.pcp ? "Yes" : "No"}
                                    </Text>
                                    <Text variant="small" className={tierMetaClass}>
                                        Out Of Network: {t.ion ? "Yes" : "No"}
                                    </Text>
                                </Stack>
                            ))}
                        </Stack>
                    </td>
                </tr>

                {showFundingType &&
                    <tr>
                        <td style={styleSummary.dt}><Text styles={headerStyles}>Funding Type</Text></td>
                        <td style={styleSummary.dd}><Text>{benefit.fundingType?.name ?? '-'}</Text></td>
                    </tr>
                }

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>GF/NGF Type</Text></td>
                    <td style={styleSummary.dd}><Text>{benefit.grandFathered?.name ?? '-'}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Status</Text></td>
                    <td style={styleSummary.dd}><Text>{benefit.status.name ?? '-'}</Text></td>
                </tr>

                <tr>
                    <td style={styleSummary.dt}><Text styles={headerStyles}>Deactivated</Text></td>
                    <td style={styleSummary.dd}><Text>{benefit.deactivated ? 'Yes' : 'No'}</Text></td>
                </tr>

            </tbody>

        </table>
    );
};

export default BenefitSummary;